import React, { useRef, useState, useCallback } from 'react';
import { ReactEditor, useEditor } from 'slate-react';
import { useDndEnd } from '../dnd';
import { TopLevelComponent } from '../components';
import TopLevelBlockComponent from '../components/TopLevelBlock';
import DraggableLeftGutter from './DraggableLeftGutter';
import { TasquetMarkdownEditor } from '../../command';
const TopLevelBlock = (props) => {
    const ref = useRef(null);
    const [dragHovering, setHovering] = useState('none');
    const editor = useEditor();
    const [dragItem, dropHandler] = useDndEnd();
    return (React.createElement(TopLevelBlockComponent, { ref: ref, topDropTarget: dragHovering === 'upper', bottomDropTarget: dragHovering === 'lower', onDragOver: useCallback((e) => {
            if (dragItem == null) {
                return;
            }
            e.preventDefault();
            let newState = 'upper';
            if (ref.current) {
                const dom = ref.current;
                const rect = dom.getBoundingClientRect();
                const offsetY = e.clientY - rect.y;
                if (offsetY > rect.height / 2) {
                    newState = 'lower';
                }
            }
            // Reduce state updates to suppress rendering
            if (dragHovering !== newState) {
                setHovering(newState);
            }
        }, [dragItem, dragHovering]), onDragLeave: useCallback(() => {
            setHovering('none');
        }, []), onDrop: useCallback(() => {
            setHovering('none');
            dropHandler();
            if (dragItem == null) {
                return;
            }
            const srcIndices = dragItem.srcIndices;
            const dstPath = ReactEditor.findPath(editor, props.element);
            let dstIndex = dstPath[0];
            if (srcIndices.includes(dstIndex)) {
                return;
            }
            if (Math.max(...srcIndices) < dstIndex) {
                dstIndex--;
            }
            if (dragHovering === 'lower') {
                dstIndex++;
            }
            TasquetMarkdownEditor.moveTopLevelElement(editor, srcIndices, dstIndex);
        }, [dropHandler, editor, props.element, dragItem, dragHovering]) },
        React.createElement(DraggableLeftGutter, { element: props.element, previewRef: ref }),
        React.createElement(TopLevelComponent, Object.assign({ element: props.element }, props.attributes), props.children),
        props.Gutter));
};
export default React.memo(TopLevelBlock);
//# sourceMappingURL=index.js.map